<div class="reward-criteria-section reward-criteria-v2">
  <div class="reward-criteria-card">
    <div class="criteria-image">
      <img src="assets/images/rewards.png" alt="Rewards" width="80" height="80">
    </div>
    <div class="criteria-content">
      <h3 class="criteria-title">Reward Earning Criteria</h3>
      <div class="criteria-list">
        <span class="criteria-text" *ngIf="isLoading">Loading...</span>
        <span class="criteria-text" *ngIf="!isLoading && activeRules.length === 0">
          No active reward rules configured.
        </span>
        <span class="criteria-text" *ngIf="!isLoading && activeRules.length > 0">
          {{ criteriaText }}
        </span>
      </div>
      <app-add-button
        class="mobile-reward-button"
        buttonText="Reward Settings"
        variant="secondary"
        iconType="reward-settings"
        (buttonClick)="onRewardSettingsClick()">
      </app-add-button>
    </div>
    <app-add-button
      buttonText="Reward Settings"
      variant="secondary"
      iconType="reward-settings"
      (buttonClick)="onRewardSettingsClick()">
    </app-add-button>
  </div>
</div>
